import React from "react";
import GeneralAlert from "../components/common/GeneralAlert";
import { useNavigate } from "react-router-dom";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <GeneralAlert
      errorMessage="Page not found"
      action={() => navigate(-1)}
      actionLabel="Go Back"
    />
  );
};

export default PageNotFound;
